'use client';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { useState, useEffect } from 'react';
import { GoogleOAuthProvider, GoogleLogin, useGoogleOneTapLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { loginUser, loginUserGoogle, checkUserExists, default as registerUser } from "@/app/funcs/auth";
import { toast } from 'react-toastify';
import { isLoggedIn } from '@/app/funcs/api'


export default function LoginPage() {
    const router = useRouter();

    useEffect(() => {

        isLoggedIn().then((res) => {
            if (res) return router.push('/account');
        });

        // let token = localStorage.getItem('token');
        // if (token != null || token != undefined && (validateToken(token))) return router.push('/account');
    }, []);

    const baseURL = process.env.NEXT_PUBLIC_BASE_URL;
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const res = await fetch(`${baseURL}/api/jwt-auth/v1/token`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ username, password }),
            });

            const data = await res.json();

            if (data.token) {
                sessionStorage.setItem('token', data.token);
                localStorage.setItem('user', JSON.stringify(data));
                localStorage.setItem('token', data.token);
                // redirect or update UI
                // window.location.href = '/dashboard';
                window.location.href = '/account';
            } else {
                // setError(data.message || 'خطأ في تسجيل الدخول');
                setError("خطأ في تسجيل الدخول، إذا استمرت المشكلة تواصل مع دعم فيجمواية على مجتمع الواتسآب أو تيليجرام أو من خلال الإيميل <a href='mailto:support@figmawya.com'>support@figmawya.com</a>");
            }
        } catch (err) {
            setError('خطأ في تسجيل الدخول');
        } finally {
            setLoading(false);
        }
    };

    const handleGoogleSuccess = async (credentialResponse) => {
        try {
            const token = credentialResponse.credential;
            const userInfo = token ? jwtDecode(token) : null;
            if (!userInfo) throw new Error("Google token decode failed");

            const { email, name, given_name, family_name } = userInfo;

            // 1. Try to login with Google first (regardless of whether user exists)
            try {
                const loginData = await loginUserGoogle(email);
                localStorage.setItem("token", loginData.token);
                localStorage.setItem("user", JSON.stringify(loginData));
                toast.success("تم تسجيل الدخول بنجاح عبر Google!");
                router.push('/account');
            } catch (loginErr) {
                // If Google login fails, check if user exists
                const userExists = await checkUserExists(email);

                if (userExists) {
                    // User exists but Google login failed (probably different password)
                    toast.error("فشل تسجيل الدخول عبر Google: " + loginErr.message);
                } else {
                    // User doesn't exist, register and login
                    try {
                        await registerUser({
                            email,
                            username: email.split("@")[0],
                            password: email + "_google_secret",
                            name: name || given_name,
                            first_name: given_name,
                            last_name: family_name,
                            display_name: name,
                        });

                        // Login after registration
                        const loginData = await loginUserGoogle(email);
                        localStorage.setItem("token", loginData.token);
                        localStorage.setItem("user", JSON.stringify(loginData));
                        toast.success("تم إنشاء حسابك وتسجيل الدخول بنجاح عبر Google!");
                        router.push('/account');
                    } catch (regErr) {
                        toast.error("فشل إنشاء الحساب عبر Google: " + regErr.message);
                    }
                }
            }
        } catch (err) {
            toast.error("فشل تسجيل الدخول عبر Google: " + err.message);
            console.error(err);
        }
    };

    return (
        <div className="col-12 col-md-4 bg-white pb-3 bg-white rounded-4 p-4 mx-auto">

            {/* {baseURL + `/api/jwt-auth/v1/token`} */}
            <h2 className="mb-1 border-bottom pb-4 mb-4 lh-1">تسجيل الدخول</h2>
            <form onSubmit={handleLogin}>
                <div className="mb-3">
                    <label className="form-label w-fit">اسم المستخدم أو البريد الإلكتروني</label>
                    <input type="text" className="form-control" value={username}
                        onChange={(e) => setUsername(e.target.value)} required />
                </div>
                <div className="mb-3">
                    <label className="form-label">كلمة المرور</label>
                    <input type="password" className="form-control" value={password}
                        onChange={(e) => setPassword(e.target.value)} required />
                </div>
                {error && <div
                    className="alert alert-danger bg-red-100 col-12"
                    dangerouslySetInnerHTML={{ __html: error }}
                />}
                {/* <p>نسيت كلمة المرور ؟  تواصل مع دعم فيجماوية :<br /><a href='mailto:support@figmawya.com'>support@figmawya.com</a></p> */}
                <button className="col-12 btn btn-primary my-3" type="submit" disabled={loading}>
                    {loading ? 'جار تسجيل دخولك ...' : 'تسجيل دخول'}
                </button>
                <div className="row justifiy-content-between mx-auto">
                    <Link href="/account/forgot-password" className='col-6 col-md-5'>نسيت كلمة المرور ؟</Link>
                    <Link href="/account/signup" className='col-6 col-md-5 text-center'>إنشاء حساب</Link>
                </div>

            </form>
            <hr />
            <p className='text-center mx-auto'>أو تسجيل الدخول بحساب جووجل</p>

            <GoogleOAuthProvider clientId="972759779991-rtjp4vb13bosiv282b7nmc8tas99okae.apps.googleusercontent.com" className="mx-auto">
                <GoogleLogin
                    theme='filled_black'
                    size='large'
                    type='standard'
                    shape='pill'
                    width={380}
                    onSuccess={handleGoogleSuccess}
                    onError={() => toast.error("فشل تسجيل الدخول عبر Google")}
                    useOneTap={true}
                    auto_select={true}
                />
            </GoogleOAuthProvider>
        </div>
    );
}